import { c as _c } from "react/compiler-runtime";
import type { IdentifyRequirementLogin } from '@onefootprint/request-types';
import { AuthMethodKind } from '@onefootprint/types';
import { LinkButton } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
const TryAnotherWay = t0 => {
  const $ = _c(15);
  const {
    requirement,
    onClick
  } = t0;
  const {
    t
  } = useTranslation("identify");
  const {
    user
  } = requirement;
  const hasAuthMethodUnverifiedEmail = user?.authMethods.some(_temp);
  const isNypid = !!user?.isUnverified;
  if (!hasAuthMethodUnverifiedEmail || isNypid) {
    return null;
  }
  let t1;
  if ($[0] !== t) {
    t1 = t(_temp2);
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <span className="text-label-2 text-tertiary whitespace-nowrap fp-text" data-dd-privacy="mask">{t1} </span>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t(_temp3);
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = `inline-action:${t3}`;
  let t5;
  if ($[6] !== t) {
    t5 = t(_temp4);
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== onClick || $[9] !== t4 || $[10] !== t5) {
    t6 = <LinkButton variant="label-2" onClick={onClick} data-dd-action-name={t4}>{t5}</LinkButton>;
    $[8] = onClick;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t2 || $[13] !== t6) {
    t7 = <div className="flex flex-row gap-1 items-center justify-center w-full flex-wrap">{t2}{t6}</div>;
    $[12] = t2;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
export default TryAnotherWay;
function _temp(m) {
  return m.kind === AuthMethodKind.email && !m.isVerified;
}
function _temp2($) {
  return $["no-access-methods-label"];
}
function _temp3($_0) {
  return $_0["send-code-to-email"];
}
function _temp4($_1) {
  return $_1["send-code-to-email"];
}